<template>
  <div>
    <div id="main">
      <header>
        <button type="button" class="material-icons black" @click="closeModal">
          close
        </button>
      </header>
      <div id="audio">
        <div id="player">
          <div id="buttons">
            <button id="play" @click="playAndPause()">
              <span v-if="!isPlay" class="material-icons"> play_arrow </span
              ><span v-else class="material-icons"> pause </span>
            </button>
          </div>
        </div>
        <div class="waveform">
          <div id="waveform"></div>
          <div class="title">
            <span id="songTitle">{{ name }}</span>
            <!-- <span id="songType">{{ type }}</span> -->
          </div>
          <div id="waveform-timeline"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/wavesurfer.js/1.4.0/wavesurfer.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/wavesurfer.js/1.4.0/plugin/wavesurfer.timeline.min.js"></script>
<script>
import { eventBus } from "@/main";
export default {
  props: ["audio", "blob"],
  data() {
    return {
      settingsInfo: [],
      isPlay: false,
      track: "",
      wavesurfer: "",
      isStart: false,
      name: "",
      type: "",
    };
  },
  mounted() {
    this.wavesuferInit();
    window.console.log("blob", this.blob);
    this.track = window.document.createElement("audio");
    this.track.src = this.audio
      ? this.audio.url
      : window.URL.createObjectURL(this.blob);
    this.name = this.audio ? this.audio.title : this.blob.name;
    this.type = this.audio ? this.audio.type : this.blob.type;
  },
  methods: {
    closeModal() {
      this.wavesurfer.destroy();
      eventBus.$emit("closeModal", true);
    },
    prev() {
      window.console.log("pre");
    },
    async wavesuferInit() {
      this.wavesurfer = "";
      this.wavesurfer = await WaveSurfer.create({
        container: "#waveform",
        waveColor: "blue",
        progressColor: "orange",
        responsive: true,
        scrollParent: true,
        backgroundColor: "orange",
        closeAudioContext: true,
        showTime: true,
        // numberOfInputChannels: this.numChannels,
      });
    },
    async wavesurferStart() {
      await this.wavesurfer.load(this.track.src);

      this.wavesurfer.on("ready", async () => {
        this.isPlay = true;
        this.isStart = true;
        this.wavesurfer.play();
      });
      this.wavesurfer.on("finish", () => {
        this.wavesurfer.pause();
        this.isPlay = false;
      });
    },
    wavesurferStop() {
      this.wavesurfer.pause();
    },
    playAndPause() {
      if (this.isPlay == true) {
        window.console.log("11111");
        this.isPlay = false;
        this.wavesurferStop();
      } else if (!this.isPlay && !this.isStart) {
        window.console.log("2222");
        this.isPlay = true;
        this.wavesurferStart();
      } else {
        window.console.log("33333");
        this.isPlay = true;
        this.wavesurfer.play();
      }
    },
    next() {
      window.console.log("next");
    },
    handleVoluem() {
      window.console.log("this.track.volume", this.track.volume);
      window.console.log("this.$refs.volume.value", this.$refs.volume.value);
      let level = this.$refs.volume.value / 100;
      this.wavesurfer.setVolume(level);
    },
  },
};
</script>

<style lang="scss" scoped>
#bg {
  height: 100vh;
  width: 100%;
  position: absolute;
  overflow: hidden;
}

#bg img {
  height: 120vh;
  width: 105%;
  -webkit-filter: blur(20px);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

#blackLayer {
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index: 99;
}

#main {
  width: calc(100% - 60px);
  margin: 0 auto;
  border-radius: 15px;
}
#main header {
  display: flex;
  justify-content: flex-end;
  padding: 10px 5px;
  max-width: 800px;
  margin: 0 auto;
  button {
    background: #111;
    color: #fff;
    font-size: 16px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    text-align: center;
  }
}

#audio img {
  height: 180px;
  width: 100%;
  margin-top: -5px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
#audio {
  display: flex;
  background-color: #fff;
  max-width: 800px;
  border: 1px solid #313da1;
  border-radius: 4px;
  background: linear-gradient(#ffffff, #f2f2f2);
  justify-content: space-between;
  padding-top: 20px;
  margin: 0 auto;
  .waveform {
    width: 90%;
  }
  #player {
    padding: 10px;
    color: #333;
    #buttons {
      height: 50px;
      // width: 100%;
      transform: translate(-50%, -50%);
      margin-top: 55px;
      margin-left: 20px;

      span {
        color: #fff;
      }
    }
  }
}

#songTitle {
  font-family: monospace;
  font-size: 1.4rem;
}

#play,
#next,
#pre {
  width: 50px;
  height: 50px;
  // border: 0;
  background-color: #222;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(255, 255, 255, 0.9);
  // box-shadow: 0 3px 6px rgba(33,33,33,.1), 0 3px 12px rgba(33,33,33,.15);
}
#next {
  width: 40px;
  height: 40px;
  left: 70%;
}
#pre {
  width: 40px;
  height: 40px;
  left: 30%;
}
#play img,
#next img,
#pre img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#seek-bar {
  width: 250px;
  height: 5px;
  background-color: gray;
  display: flex;
  border-radius: 50px;
  margin-left: 25px;
  cursor: pointer;
}
#fill {
  height: 5px;
  background-color: #111;
  border-radius: 20px;
}
#handle {
  width: 8px;
  height: 8px;
  background-color: royalblue;
  border-radius: 50%;
  margin-left: -5px;
  transform: scale(2);
}

input[type="range"]::-webkit-slider-thumb {
  height: 2rem;
  width: 2rem;
  background: #ff8a65;
  border-radius: 50%;
  cursor: pointer;
}

@media all and (max-width: 1200px) {
  #audio {
    width: 100%;
  }
}
@media screen and (max-width: 540px) {
  #audio {
    width: 100%;
    padding-top: 20px;
    // border-radius: 0px;
    .waveform {
      width: 85%;
    }
  }
  #main {
    width: calc(100% - 60px);
  }
  #main header {
    button {
      font-size: 14px;
      width: 20px;
      height: 20px;
      padding: 0px;
    }
  }
  #play,
  #next,
  #pre {
    width: 40px;
    height: 40px;
  }
}

@media all and (max-width: 376px) {
  #main {
    width: calc(100% - 20px);
  }
}
</style>
